import { useMutation, useQueryClient } from 'react-query';
import { communicationKeys } from '../cache-keys/communicationKeys';
import { useAPI } from '@axo/shared/data-access/provider';
import { comment_api } from '@axo/shared/data-access/api';

export function useUpdateComment(applicationID: string) {
  const client = useQueryClient();
  const api = useAPI();

  return useMutation(comment_api.patchComment(api), {
    onSuccess: () => {
      return client.invalidateQueries(
        communicationKeys.comments({ applicationID })
      );
    },
  });
}
